import { Button } from '@components/common/Button';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { inReviewQuestions } from './questions';
import { PageURL } from '@router/pageURL';

export const InReview = () => {
  const navigate = useNavigate();

  const nextStepRedirectHandler = () => navigate(PageURL.APPLICATIONS);

  return (
    <>
      <FormattedMessage id={inReviewQuestions.inReview.note1} tagName={'p'} />
      <FormattedMessage id={inReviewQuestions.inReview.note2} tagName={'p'} />

      <div className={'mt-8 flex justify-between'}>
        <Button variant={'contained'} onClick={nextStepRedirectHandler}>
          <FormattedMessage id={'cta.continue'} />
        </Button>
      </div>
    </>
  );
};
